import React from 'react';
import { useNavigate } from 'react-router-dom';

// Single source of truth for the DotLink brand mark. Reused across every
// page so the icon, gradient and wordmark never drift out of sync.
const SIZE_MAP = {
  sm: { box: 'w-9 h-9', icon: 22, rounded: 'rounded-xl', text: 'text-lg' },
  md: { box: 'w-11 h-11', icon: 26, rounded: 'rounded-xl', text: 'text-xl' },
  lg: { box: 'w-16 h-16', icon: 32, rounded: 'rounded-2xl', text: 'text-5xl' },
};

export const LogoMark = ({ size = 'md' }) => {
  const { box, icon, rounded } = SIZE_MAP[size];
  return (
    <div className={`${box} bg-gradient-to-br from-indigo-500 via-indigo-600 to-purple-600 ${rounded} flex items-center justify-center shadow-lg`}>
      <svg width={icon} height={icon} viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="2.8" fill="white" />
        <circle cx="6" cy="12" r="2.2" fill="white" fillOpacity="0.95" />
        <circle cx="18" cy="12" r="2.2" fill="white" fillOpacity="0.95" />
        <circle cx="12" cy="6" r="2.2" fill="white" fillOpacity="0.95" />
        <circle cx="12" cy="18" r="2.2" fill="white" fillOpacity="0.95" />
      </svg>
    </div>
  );
};

const Logo = ({ size = 'md', withText = true, to = '/', className = '' }) => {
  const navigate = useNavigate();
  const { text } = SIZE_MAP[size];

  return (
    <button
      type="button"
      onClick={() => navigate(to)}
      className={`flex items-center gap-3 group bg-transparent border-0 cursor-pointer ${className}`}
    >
      <div className="group-hover:scale-105 transition-transform">
        <LogoMark size={size} />
      </div>
      {withText && (
        <span className={`${text} font-bold text-gray-800 max-[339px]:hidden`}>DotLink</span>
      )}
    </button>
  );
};

export default Logo;
